import {Spell, SpellSummary} from "@/spells/model/Spell.ts";
import {getSchoolAttributes} from "@/spells/model/SpellSchools.ts";

export function displaySpellLevel(level: number): string {
    return level === 0 ? "Zaubertrick" : `${level}. Grad`;
}

export function displaySpellSchool(spell: Spell | SpellSummary): string {
    const school = getSchoolAttributes(spell);
    if (spell.level === 0) return `Zaubertrick der ${school.label}`;
    return `${school.label} des ${spell.level}. Grades${spell.ritual ? " (Ritual)" : ""}`;
}
